export default __webpack_public_path__ + "static/media/yandex.b95d76c0.svg";